import Application from './Application';
import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
        ...state
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {}
}

const ConnectedApplication = connect(
    mapStateToProps,
    mapDispatchToProps
  )(Application);

export default ConnectedApplication;